import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateBookingStatus = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateBookingStatus.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
